import React from 'react';
import {HeroProduct} from "../../components/hero/HeroProduct";
import {Col, Container, Row} from 'reactstrap';
import {CaseStoriesCarousel} from "../../components/case-stories/CaseStoriesCarousel";
import {ContactUsHiddenFormSection} from "../../components/contact-us/ContactUsHiddenFormSection";
import {NewsListSection} from "../../components/news/NewsListSection";
import {VariantList} from "../../components/variant-list/VariantList";
import {connect} from "react-redux";
import {fetchAllPages} from "../../util/wpapi_util";
import {BasicAnimation} from "../../components/animations/BasicAnimation";
import {Helmet} from "react-helmet";
import striptags from "striptags";

class ProductViewContainer extends React.Component {

  constructor(props) {
    super(props);

    this.state = { // eslint-disable-next-line
      product: this.props.product,
    };

    this.fetchRelatedCaseStories = this.fetchRelatedCaseStories.bind(this);
    this.fetchVariants = this.fetchVariants.bind(this);

    this.fetchRelatedCaseStories();
  }

  fetchRelatedCaseStories() {
    if (this.state.product
      && this.state.product.acf
      && this.state.product.acf.related_posts) {

      this.props.wpapi
        .news()
        .include(this.state.product.acf.related_posts)
        .then(response => {
          console.log(response);
          const product = {...this.state.product, related_case_stories: response};
          this.setState({
            product
          })
        });
    }
  }

  fetchVariants() {
    if (this.state.product && this.state.product.acf &&
      Array.isArray(this.state.product.acf.obx_product_variants) &&
      this.state.product.acf.obx_product_variants.length > 0) {

      this.setState({
        variants_loading: true
      });

      const apiCall = this.props.wpapi
        .variants()
        .include(this.state.product.acf.obx_product_variants
          .map(variant => variant.ID))
        .perPage(100);

      fetchAllPages(apiCall)
        .then(
          response => {
            const variants = response.sort((a, b) => {
              if (!a.title) {
                return -1;
              } else if (!b.title) {
                return 1;
              } else if (a.title.rendered < b.title.rendered) {
                return -1;
              } else if (a.title.rendered > b.title.rendered) {
                return 1;
              } else {
                return 0;
              }
            });

            this.setState({
              variants,
              variants_loading: false
            });
          },
          () => {
            this.setState({
              variants_loading: false
            });
          }
        );
    }

  }

  componentWillMount() {
    this.fetchVariants();
  }

  shouldComponentUpdate(nextProps, nextState) {
    return Boolean(
      (!nextState.variants_loading && this.state.variants_loading) ||
      (!this.state.product && nextState.product) ||
      (this.state.product && nextState.product && this.state.product.id !== nextState.product.id) ||
      (nextState.product && nextState.product.related_case_stories)
    );
  }

  componentWillReceiveProps(nextProps) { // eslint-disable-next-line
    const product = this.props.product;

    if (this.state.product && product && product.id !== this.state.product.id) {
      this.setState(
        {product},
        () => {
          this.fetchRelatedCaseStories();
          this.fetchVariants();
        }
      );
    }

  }

  render() {
    if(!this.props.product)
      return null;

    let productImage = null;
    let keyFeatures = null;
    let opticalCharacteristics = null;
    let specificationsMet = null;
    let description = null;
    let manual = null;
    let datasheet = null;
    let characteristicRow = [];

    try {
      productImage = this.state.product._embedded["wp:featuredmedia"][0].source_url;
    } catch (e) {
    }

    if (this.state.product && this.state.product.acf) {
      description = this.state.product.acf.obx_product_description;
      manual = this.state.product.acf.obx_product_manual;
      datasheet = this.state.product.acf.obx_product_datasheet;

      if (Array.isArray(this.state.product.acf.obx_product_key_features)) {

        keyFeatures = this.state.product.acf.obx_product_key_features
          .map((result, index) => {
            if (!result.obx_key_feature)
              return null;

            return (
              <li key={index}>{result.obx_key_feature}</li>
            );
          })
          .filter(n => n);

        keyFeatures = keyFeatures.length === 0
          ? null
          : <ul className="key-features-list"> {keyFeatures} </ul>;
      }

      if (description) {
        characteristicRow.push([
          <div>{description}</div>
        ]);
      }


      if (Array.isArray(this.state.product.acf.obx_product_optical_characteristics)) {

        opticalCharacteristics = this.state.product.acf.obx_product_optical_characteristics
          .map((result, index) => {
            if (!result.obx_optical_characteristic)
              return null;

            return (
              <li key={index}>{result.obx_optical_characteristic}</li>
            );
          })
          .filter(n => n);

        opticalCharacteristics = opticalCharacteristics.length === 0
          ? null
          : <ul className="optical-characteristics-list"> {opticalCharacteristics} </ul>;

        if (opticalCharacteristics) {
          characteristicRow.push([
            <h2 className={"list-header"}>Optical Characteristics</h2>,
            <div>{opticalCharacteristics}</div>
          ]);
        }

      }

      if (Array.isArray(this.state.product.acf.obx_product_specifications_met)) {
        specificationsMet = this.state.product.acf.obx_product_specifications_met
          .map((result, index) => {
            if (!result.obx_specification)
              return null;

            return (
              <li key={index}>{result.obx_specification}</li>
            );
          })
          .filter(n => n);

        specificationsMet = specificationsMet.length === 0
          ? null
          : <ul className="specifications-met-list"> {specificationsMet} </ul>;

        if (specificationsMet) {
          characteristicRow.push([
            <h2 className={"list-header"}>Design to meet</h2>,
            <div>{specificationsMet}</div>
          ]);
        }
      }

      if(typeof this.state.product.acf.obx_custom_characteristics_title === 'string'
         && Array.isArray(this.state.product.acf.obx_custom_characteristics_list)){
        let list = this.state.product.acf.obx_custom_characteristics_list
          .map((result, index) => {
            if (!result.obx_custom_characteristic)
              return null;

            return (
              <li key={index}>{result.obx_custom_characteristic}</li>
            );
          })
          .filter(n => n);

        list = list.length === 0
          ? null
          : <ul className="custom-characteristics-list"> {list} </ul>;


        if (list && characteristicRow.length < 3) {
          characteristicRow.push([
            <h2 className={"list-header"}>{this.state.product.acf.obx_custom_characteristics_title}</h2>,
            <div>{list}</div>
          ]);
        }
      }

      characteristicRow = characteristicRow.map( (c,i) => {
        let props = {};
        let colProps = {};

        colProps.size = 12/characteristicRow.length;

        if(i === 0){
          props.className = "product-description";
          if(characteristicRow.length === 1){
            props.style = { textAlign: "center"};
            colProps.size = 8;
            colProps.offset = 2;
          }
        }

        return (
          <Col xs="12" md={{ ...colProps }} { ...props }>
            {c}
          </Col>
        );
      });

    }

    return (
      <div>

        <Helmet>
          <title>{ (this.state.product && this.state.product.title.rendered) + " | Obelux Aviation Lights" }</title>
          <meta name="description" content={ description ? description : '' }></meta>
          <meta name="og:description" content={ description ? description : '' }></meta>
          <meta name="og:image" content={require('../../assets/images/obelux.jpg')}></meta>
        </Helmet>

        <header>
          <HeroProduct title={(this.state.product && this.state.product.title.rendered) || ""}
                       image={productImage}
                       subtitle={keyFeatures}
                       manual={manual}
                       datasheet={datasheet}
          />
        </header>
        <BasicAnimation duration={400} delay={0}>
          <Container className={"floating-bar"}>
            <Row>
              <Col className={"pr-0"} style={{ whiteSpace: 'nowrap'}}>
                <div className={"contacts"}>
                  <div className={"floating-bar-contact-info"}>
                    <h1>Contact Us</h1>
                    <a href="mailto:info@obelux.fi">info@obelux.fi</a>
                  </div>
                </div>
              </Col>
              <Col className={"pl-0"}>
                <div className={"downloads"}>
                  {
                    (manual || datasheet) &&
                    <span className={"download-header"}>Download</span>
                  }
                  {
                    (datasheet) &&
                    <a href={datasheet.url} target="_blank" rel="noopener noreferrer" className={"download-button"}>
                      <div className={"button-text"}>
                        Datasheet
                      </div>
                    </a>
                  }
                  {
                    (manual) &&
                    <a href={manual.url} target="_blank" rel="noopener noreferrer" className={"download-button"}>
                      <div className={"button-text"}>
                        Manual
                      </div>
                    </a>
                  }
                </div>
              </Col>
            </Row>
          </Container>
        </BasicAnimation>


        {
          characteristicRow.length > 0 &&
          <div className={"obelux-background"}>
            <BasicAnimation duration={200} delay={200}>
              <Container className={"product-desc"}>
                <Row>
                  {characteristicRow}
                </Row>
              </Container>
            </BasicAnimation>
          </div>
        }
        {
          (Array.isArray(this.state.variants) || this.state.variants_loading) &&
          <VariantList data={this.state.variants} loading={this.state.variants_loading}/>
        }
        <BasicAnimation duration={400} delay={0}>
          <ContactUsHiddenFormSection/>
        </BasicAnimation>
        <CaseStoriesCarousel caseStoryList={this.state.product.related_case_stories}/>
        <NewsListSection/>
      </div>
    );
  }
}

export const ProductView = connect(
  state => ({
    wpapi: state.WPAPI.instance,
    product: state.resolve.data && state.resolve.data.product
  })
)(ProductViewContainer);



// WEBPACK FOOTER //
// ./src/views/products/ProductView.js